$(document).on('click', '.popup-open', function(e){
  if( $("#jtplPopup").length >0){
  $("#jtplPopup").addClass('is-open');
  $(".popup-overlay").addClass('is-open');
  $("body").addClass("is-open-popup-body");
  }
});

$(document).on('click', '.popup-close', function(e){
  $(".modal-popup").removeClass('is-open');
  $(".popup-overlay").removeClass('is-open');
  $("body").removeClass("is-open-popup-body");
});

$(document).on('click', '.popup-overlay', function(e){
  $(".modal-popup").removeClass('is-open');
  $(".popup-overlay").removeClass('is-open');
  $("body").removeClass("is-open-popup-body");
});

setInterval(function(){
  $(".modal--quick-shop .popup-open").click(function(e){
    e.stopPropagation();
    if($(this).parents('.modal--quick-shop').find(".modal-popup").length >0){
    $(this).parents('.modal--quick-shop').find(".modal-popup").addClass('is-open');
    $(this).parents('.modal--quick-shop').find(".popup-overlay").addClass('is-open');
    $("body").addClass("is-open-popup-body");
    }
  });
  
  $(".modal--quick-shop .popup-close").click(function(e){
    e.stopPropagation();
    $(this).parents('.modal--quick-shop').find(".modal-popup").removeClass('is-open');
    $(this).parents('.modal--quick-shop').find(".popup-overlay").removeClass('is-open');
    $("body").removeClass("is-open-popup-body");
  });
  
  $(".modal--quick-shop .popup-overlay").click(function(e){
    e.stopPropagation();
    $(this).parents('.modal--quick-shop').find(".modal-popup").removeClass('is-open');
    $(this).parents('.modal--quick-shop').find(".popup-overlay").removeClass('is-open');
    $("body").removeClass("is-open-popup-body");
  });
},100);
 
var i,acc=document.getElementsByClassName("accordion");for(i=0;i<acc.length;i++)acc[i].addEventListener("click",function(){this.classList.toggle("active");var e=this.nextElementSibling;e.style.maxHeight?e.style.maxHeight=null:e.style.maxHeight=e.scrollHeight+"px"});$("button.accordion").on("click",function(){$(this).children("svg.icon.icon--wide.icon-chevron-down").toggleClass("active")}),$(".custom_overflow .color-swatch").on("mouseenter",function(){$el=$(this);var e=$el.data("variant-id"),o=$el.data("variant-image");$(".grid-product__color-image--"+e).css("background-image","url("+o+")").addClass("is-active "),$(this).parents().find(".grid-product__color-image").each(function(){var t=$(this).attr("data-varid");e==t?($(this).css("background-image","url("+o+")").addClass("is-active "),console.log("here is code 5317 line")):$(this).removeClass("is-active")})}),$(".variant__button-label").click(function(){$(window).width()<=768&&(console.log("Mobile"),$("html, body").animate({scrollTop:$("body").offset().top},2e3))}),$(document).on("click",".login_plus_account a",function(){var e=$(this).parents(".login_plus_account").attr("page-url");if(Cookies.set("Product_url_login",e,{expires:1,path:"/"}),Cookies.get("Product_url_login"))Cookies.get("Product_url_login")}),$(document).ready(function(){if(Cookies.get("Product_url_login")){var e=Cookies.get("Product_url_login");if(Cookies.get("Product_url_login")){var o=Cookies.get("Product_url_login");$("input.redirection_to_pdp").val(o)}if(window.location.href.includes("challenge")){o=Cookies.get("Product_url_login");$("<input class='custom_url_here' type='hidden' name='checkout_url' value='"+o+"'>").insertBefore($("form").find("input.shopify-challenge__button"))}else console.log("challenge not ");if($(document).on("click","input.shopify-challenge__button",function(){var o=e;if(Cookies.set("captcha_cookie",o,{expires:1,path:"/"}),Cookies.get("captcha_cookie"))Cookies.get("captcha_cookie")}),Cookies.get("captcha_cookie")){var t=Cookies.get("captcha_cookie"),i=window.location.href;t&&"https://imotorcycle.myshopify.com/"==i&&(window.location.replace(t),document.cookie="captcha_cookie=; path=/;")}}}),$("ul.mobile-nav__grandchildlist li.mobile-nav__item a.mobile-nav__link").click(function(){location.reload()}),$(".input-group-btn").click(function(){$(".header-sticky-wrapper .header-wrapper .site-header .Main-logo-with-search-custom .custom-search-here").addClass("active"),$(".search-main form.input-group.search-bar input.input-group-field").focus()}),$(".search-bar__actions.header").click(function(){$(".header-sticky-wrapper .header-wrapper .site-header .Main-logo-with-search-custom .custom-search-here").removeClass("active")}),$(document).mouseup(function(e){0===$(e.target).closest("#search_id").length&&$(".header-sticky-wrapper .header-wrapper .site-header .Main-logo-with-search-custom .custom-search-here").removeClass("active")}),$(document).on("click",".panel img.mobile-product_graph_image",function(){$(".mobile-popup.overlay").addClass("popup-active")}),$(document).on("click",".mobile-popup.overlay .popup a.close",function(){$(".mobile-popup.overlay").removeClass("popup-active")}),$(document).on("click",".collapsible-content__inner img.desktop-product_graph_image",function(){$(".desktop-popup.overlay").addClass("popup-active")}),$(document).on("click",".desktop-popup.overlay .popup a.close",function(){$(".desktop-popup.overlay").removeClass("popup-active")}),$(".catg-wrap a").click(function(e){setTimeout(function(){var e=$(location).attr("href").split("#"),o=e[e.length-1];console.log(o);var t=$(".site-header-sticky").height();$("html, body").animate({scrollTop:$("div#"+o).offset().top-t},2e3)},100)}),$("ul.site-nav__dropdown.text-left li.site-nav__deep-dropdown-trigger ul.site-nav__deep-dropdown li").click(function(){if(setTimeout(function(){var e=$(location).attr("href").split("#"),o=e[e.length-1];console.log(o);var t=$(".site-header-sticky").height();$("html, body").animate({scrollTop:$("div#"+o).offset().top-t},2e3)},100),window.location.href.indexOf("#sc-project")>-1){var e=$(".site-header-sticky").height();$("html, body").animate({scrollTop:$("div#sc-project").offset().top-e},2e3)}}),$(document).ready(function(){if(setTimeout(function(){var e=$(location).attr("href").split("#"),o=e[e.length-1];console.log(o);var t=$(".site-header-sticky").height();$("html, body").animate({scrollTop:$("div#"+o).offset().top-t},2e3)},100),window.location.href.indexOf("#sc-project")>-1){var e=$(".site-header-sticky").height();$("html, body").animate({scrollTop:$("div#sc-project").offset().top-e},2e3)}}),$(document).on("click",".desktop-popup.content img.product_graph_image",function(){$(".desktop-popup.overlay.popup-active").toggleClass("image_active")}),$(".slideshow-section-images-slider").slick({slidesToShow:1,slidesToScroll:1,arrows:!0,autoplay:!0,fade:!0,adaptiveHeight:!0,dots:!0}),$(document).ready(function(){window.dispatchEvent(new Event("resize"))}),window.onload=function(){window.dispatchEvent(new Event("resize"))},document.addEventListener("DOMContentLoaded",function(e){window.dispatchEvent(new Event("resize"))}),window.location.href.indexOf("customer_posted=true")>-1&&function(e){e(document).ready(function(){e("html, body").animate({scrollTop:e(".footer__newsletter").offset().top},1e3)})}(jQuery),window.location.href.indexOf("challenge#newsletter-footer")>-1&&function(e){e(document).ready(function(){e("html, body").animate({scrollTop:e("header.site-header").offset().top},1e3)})}(jQuery),$(document).ready(function(){function e(){$(window).width()>768?$(".brand_Mobile_text_columns").hasClass("slick-initialized")&&($(".brand_Mobile_text_columns").slick("unslick"),$(".brand_Mobile_text_columns").removeClass("slick-initialized slick-slider")):$(".brand_Mobile_text_columns").hasClass("slick-initialized")||$(".brand_Mobile_text_columns").slick({arrows:!0,infinite:!0,autoplay:!0,autoplaySpeed:1500,slidesToShow:3,slidesToScroll:1,prevArrow:" <button class='brand_Mobile_text_columns_left arrow arrow-left'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon--wide icon-chevron-down' viewBox='0 0 28 16'><path d='M1.57 1.59l12.76 12.77L27.1 1.59' stroke-width='2' stroke='#000' fill='none' fill-rule='evenodd'></path>Shipping &amp; Returns</svg></button>",nextArrow:"<button class='brand_Mobile_text_columns_right arrow arrow-right'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon--wide icon-chevron-down' viewBox='0 0 28 16'><path d='M1.57 1.59l12.76 12.77L27.1 1.59' stroke-width='2' stroke='#000' fill='none' fill-rule='evenodd'></path>Shipping &amp; Returns</svg></button>",responsive:[{breakpoint:480,settings:{slidesToShow:1}}]})}console.log("ready"),e(),$(window).resize(function(){e()})}),jQuery(document).ready(function(){$(".More-than-five-products").slick({dots:!0,infinite:!1,slidesToShow:5,slidesToScroll:1,prevArrow:" <button class='arrow arrow-left'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon--wide icon-chevron-down' viewBox='0 0 28 16'><path d='M1.57 1.59l12.76 12.77L27.1 1.59' stroke-width='2' stroke='#000' fill='none' fill-rule='evenodd'></path>Shipping &amp; Returns</svg></button>",nextArrow:"<button class='arrow arrow-right'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon--wide icon-chevron-down' viewBox='0 0 28 16'><path d='M1.57 1.59l12.76 12.77L27.1 1.59' stroke-width='2' stroke='#000' fill='none' fill-rule='evenodd'></path>Shipping &amp; Returns</svg></button>",responsive:[{breakpoint:1025,settings:{slidesToShow:4,slidesToScroll:1}},{breakpoint:790,settings:{slidesToShow:3,slidesToScroll:1}},{breakpoint:550,settings:{slidesToShow:1,slidesToScroll:1}}]})});
jQuery(".product__thumbs").on('wheel', (function(e) {
  e.preventDefault();
  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickPrev');
  } else {
    $(this).slick('slickNext');
  }
}));
$(window).on('load', function(){

  setTimeout(function(){

    all_price();
  }, 1200);  
});

function all_price(){
  var total = 0;
   var totalComapre = 0; 
   var regular = 0;
   var sales = 0;
  if($("span.cbb-frequently-bought-selector-label-sale-price").length > 0){
      $("span.cbb-frequently-bought-selector-label-sale-price span.money").each(function(){
          var final_price1 = $(this).text().replace("," , "").replace("¥" , "");     
            var shipcost = parseInt(final_price1)/10;
            var totalcost = parseInt(final_price1)+shipcost;
            total +=parseInt(totalcost);
            $(this).parent().find(".all-prices").remove();
            $(this).hide();
            var actual =theme.Currency.formatMoney(totalcost*100,theme.settings.moneyFormat);  
            $('<span class="all-prices">'+actual+' (税込)</span>').insertAfter(this);
            sales++;
      });
    }
   if($(".cbb-frequently-bought-selector-label-compare-at-price").length > 0){
        $(".cbb-frequently-bought-selector-label-compare-at-price span.money").each(function(){
            var final_price1 = $(this).text().replace("," , "").replace("¥" , "");
          var shipcost = parseInt(final_price1)/10;
          var totalcost = parseInt(final_price1)+shipcost;
          totalComapre +=parseInt(totalcost);
           console.log(final_price1+"==="+totalcost);
         $(this).parent().find(".all-prices").remove();
          $(this).hide();
          var actual =theme.Currency.formatMoney(totalcost*100,theme.settings.moneyFormat);  
          $('<span class="all-prices">'+actual+' (税込)</span>').insertAfter(this);
      });


  }
   if($("span.cbb-frequently-bought-selector-label-regular-price").length > 0){
        $("span.cbb-frequently-bought-selector-label-regular-price span.money").each(function(){

          if($(this).parents("li").find(".cbb-frequently-bought-selector-input").prop("checked") == true){

            var final_price1 = $(this).text().replace("," , "").replace("¥" , "");
          
            var shipcost = parseInt(final_price1)/10;
            var totalcost = parseInt(final_price1)+shipcost;
            total +=parseInt(totalcost);
             totalComapre +=parseInt(totalcost);
            $(this).parent().find(".all-prices").remove();
            $(this).hide();
            var actual =theme.Currency.formatMoney(totalcost*100,theme.settings.moneyFormat);  
            $('<span class="all-prices">'+actual+' (税込)</span>').insertAfter(this);
            regular++;
          }
        });
      }
  var orgtotal =theme.Currency.formatMoney(total*100,theme.settings.moneyFormat);  
  $(".money.tax-included").remove();
  $(".cbb-frequently-bought-total-price-sale-price .money").hide();
   if($("span.cbb-frequently-bought-total-price-regular-price").length > 0){
      $('<span class="money tax-included">'+orgtotal+' (税込)</span>').insertAfter("span.cbb-frequently-bought-total-price-regular-price span.money");
   }
   if($("span.cbb-frequently-bought-total-price-sale-price").length > 0){
     $(".cbb-frequently-bought-total-price-sale-price .money").hide();
      $('<span class="money tax-included">'+orgtotal+' (税込)</span>').insertAfter("span.cbb-frequently-bought-total-price-sale-price span.money");
   }
   
    $(".cbb-frequently-bought-total-price-was-price").show();
    if($(".cbb-frequently-bought-total-price-was-price").length > 0){
        $(".cbb-frequently-bought-total-price-was-price .money").hide();
        var orgtotalComapre = theme.Currency.formatMoney(totalComapre*100,theme.settings.moneyFormat); 
          $('<span class="money tax-included">'+orgtotalComapre+' (税込)</span>').insertAfter(".cbb-frequently-bought-total-price-was-price span.money");
      }
   
   

}

$(document).on("change",".cbb-recommendations-variant-select",function(){
  all_price();
});
$(document).on("click",".cbb-frequently-bought-selector-list .cbb-frequently-bought-selector-input",function(){
  setTimeout(function(){
    all_price();
  }, 1000);

});
$(".variant-input input").click(function(){
  setTimeout(function(){
    all_price();
  }, 1000);
});

$('.brand_section_right.mobile_slider').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:true,
});

$(document).on('change','.variant-input input',function(){
  setTimeout(function(){
    var PageURL= window.location.href;
    var splitPageURL = PageURL.split('?variant=');
    var image= $('.noImageChange p[data-id="'+splitPageURL[1]+'"]').attr('data-image');
    var imageSplit= image.split('?');
    if($(window).width() > 768){
      $('.product__thumbs .product__thumb-item').each(function(){
        var thumbsImage = $(this).find('a').attr('href');
        var thumbsImageSplit= thumbsImage.split('?');
        if( thumbsImageSplit[0] == imageSplit[0]){
          $(this).trigger('click');
        }
      });
    }
    else{
      $('.product__main-photos .Main_imageQuickview .starting-slide').each(function(){
        var thumbsImage = $(this).find('img.photoswipe__image').attr('data-photoswipe-src');
        var thumbsImageSplit= thumbsImage.split('?');
        if( thumbsImageSplit[0] == imageSplit[0]){
          var Imagescount= $(this).attr('data-slick-index');
          $('.Main_imageQuickview').slick('slickGoTo', Imagescount);
        }
      });
    }
    var get_exist = $(".product-single__variants option:selected").attr('data-exist-notify');
    var get_qty = $(".product-single__variants option:selected").attr('data-leftquantity');
    if (typeof get_exist  !== "undefined"){
      if(get_exist == 'true' && get_qty < 1 ){
      $(".product-single__form").addClass('unhide_bt');
      $(".product-single__form").removeClass('hide_btn');
      
      }else{
      
      $(".product-single__form").addClass('hide_btn');
      $(".product-single__form").removeClass('unhide_bt');
      
      }
}
  },500);
  setTimeout(function(){
    var get_opt_val= $("select.product-single__variants option:selected").val();
    var get_qty_val= $("select.product-single__variants option:selected").attr("quantity");
 $(".custom_main_add-cart").attr("data-id",get_opt_val);
 $(".custom_main_add-cart").attr("qty",get_qty_val);
    var variant_sku = $(".modal--quick-shop.modal--is-active select.product-single__variants option:selected").attr("data-sku");
$(".modal--quick-shop.modal--is-active p.main_sku_data .product_sku").html(variant_sku);
  },200);
$("p.delivery_time-sku-wrapp").hide();
  var GetValue= $(this).val();
  console.log("GetValue"+ GetValue);
  $(this).parents(".variant-wrapper").find('label .variant__label-info').html(GetValue);
        var checkedtext ='';
        $(".modal.modal--square.modal--quick-shop.modal--is-active .product-single__form").find(" .variant-input-wrap .variant-input input").each(function(){
          if ($(this).is(":checked"))
          {
            checkedtext += $(this).val()+" / ";
          }
        });
        var newname = checkedtext.slice(0,-2);
        var FinalValue= jQuery.trim(newname);
        var existValue = jQuery('.modal--is-active .product-single__variants option[data-vartitle="'+FinalValue+'"]').attr('data-exist');
        var vartitle = jQuery('.modal--is-active .product-single__variants option[data-vartitle="'+FinalValue+'"]').attr('data-vartitle');
        if(existValue=='true'){
        }
           $(".Main--stock_status_plus_delivery_time.default").hide();
          $(".final_stock_status.stock_status").show();
  
            var get_value = $('.modal--quick-shop.modal--is-active .product-single__variants').find(":selected").attr("data-stockval");
             var data_vendor = $('.modal--quick-shop.modal--is-active .product-single__variants').find(":selected").attr("data-vendor");
             var discontinuted_text = $(".modal--quick-shop.modal--is-active .discontinuted_text").text();
             var stocktextJapan=$('.modal--quick-shop.modal--is-active .product-single__variants').find(":selected").attr("data-checked");
             var current_variant_inventory_quantity =$('.modal--quick-shop.modal--is-active .product-single__variants').find(":selected").attr("data-leftquantity");
             var progress_width =$('.modal--quick-shop.modal--is-active .product-single__variants').find(":selected").attr("data-leftquantity");
             var Final_progress_width =parseInt(progress_width) * 10 ;
             var Selected_variant_quantity =parseInt($('.modal--quick-shop.modal--is-active .product-single__variants').find(":selected").attr("data-leftquantity")); 
             var Final__parseInt_quantity1 =parseInt($(".quantity_1").attr("data-maxquantity")); // managed by customize settings
             var Final__parseInt_quantity2 =parseInt($(".quantity_2").attr("data-maxquantity")); // managed by customize settings
             var Final__parseInt_quantity3 =parseInt($(".quantity_3").attr("data-maxquantity"));               // managed by customize settings
             var Variant_title=$('.product-single__variants').find(":selected").attr("data-vartitle");// Get the selected variant title
             // Remove Both the line item Properties            
             $('.modal--quick-shop.modal--is-active .product-single__form .form-delivery-date').remove();
             $('.modal--quick-shop.modal--is-active .product-single__form .form-Stock-status').remove();

          if( get_value === undefined ){
               $(".stock_status span.ss").text(discontinuted_text);
               $(".stock_status span.ss").removeClass("available");
               $(".final_customdelivery_time_here.delivery_time").hide();
               $(".modal--quick-shop.modal--is-active .Deadline_Timer").hide();
               $(".modal--quick-shop.modal--is-active .Quantity-with-progress-bar").removeClass("Present");
        
             }
             else if(stocktextJapan ==='available'){
               $(".stock_status span.ss").text(get_value);
               $(".stock_status span.ss").addClass("available");
               $(".final_customdelivery_time_here.delivery_time").hide();
               $(".modal--quick-shop.modal--is-active .Deadline_Timer").css("display","flex");
               $(".modal--quick-shop.modal--is-active .current_variant_inventory_quantity").html(current_variant_inventory_quantity);
               $(".modal--quick-shop.modal--is-active .progress-bar-color").css("width",Final_progress_width+"%");
               $(".modal--quick-shop.modal--is-active .Variant-title-with-ratio .Variant-title").html(Variant_title);
               $(".modal--quick-shop.modal--is-active .Quantity-with-progress-bar").addClass("Present");
               $(".modal--quick-shop.modal--is-active .progress-bar-color").removeClass("less-than-5");
               $(".modal--quick-shop.modal--is-active .progress-bar-color").removeClass("more-than-10");
               $(".modal--quick-shop.modal--is-active .progress-bar-color").removeClass("more-than-5");
               if ( Final__parseInt_quantity1 >= Selected_variant_quantity ){
                 $(".modal--quick-shop.modal--is-active .progress-bar-color").addClass("less-than-5");
               }
               else if( Final__parseInt_quantity2 >= Selected_variant_quantity ){
                 $(".modal--quick-shop.modal--is-active .progress-bar-color").addClass("more-than-5");
               }
               else{
                 if ( Final__parseInt_quantity3 > Selected_variant_quantity ){
                   $(".modal--quick-shop.modal--is-active .progress-bar-color").addClass("more-than-10");
                 }
               }
            $('.modal--quick-shop.modal--is-active .product-single__form').append('<input type="hidden" class="form-Stock-status" name="properties[在庫状況]" value="">');          
            $('.modal--quick-shop.modal--is-active .product-single__form .form-Stock-status').val(get_value);

            }
            else{
              $(".modal--quick-shop.modal--is-active .Deadline_Timer").hide();
              $(".final_customdelivery_time_here.delivery_time").show();
              $(".stock_status span.ss").text(get_value);
              $(".delivery_time span.dt").text(data_vendor);
              $(".stock_status span.ss").removeClass("available");
               $(".modal--quick-shop.modal--is-active .Quantity-with-progress-bar").removeClass("Present");
            $('.modal--quick-shop.modal--is-active .product-single__form').append('<input type="hidden" class="form-Stock-status" name="properties[在庫状況]" value=""><input type="hidden" class="form-delivery-date" name="properties[納期]" value="">');          
            $('.modal--quick-shop.modal--is-active .product-single__form .form-delivery-date').val(data_vendor);
            $('.modal--quick-shop.modal--is-active .product-single__form .form-Stock-status').val(get_value);
            
            }
});

$(document).ready(function(){
    
$('.custom_article_tags_category a').click(function (e) {
    e.preventDefault();
var getUrl = $(this).text();
 // alert('='+getUrl);
    //console.log(getUrl);
    var getCurrentUrl  = window.location.href;
    //console.log(getCurrentUrl);
    setTimeout(function() { 
    var getSplit = getCurrentUrl.split('/articles')[0];
    //console.log(getSplit);
    var createNewurl = getSplit+'/articles/tagged/'+getUrl;
    //console.log(createNewurl);
   window.location.replace(createNewurl);
      }, 100);

});

    $('body').on('click','span.breadcrumbs__current.cstm_active_jtpl',function () {
var getUrl = $(this).text();
 // alert('='+getUrl);
    //console.log(getUrl);
    var getCurrentUrl  = window.location.href;
    //console.log(getCurrentUrl);
    setTimeout(function() { 
    var getSplit = getCurrentUrl.split('/articles')[0];
    //console.log(getSplit);
    var createNewurl = getSplit+'/articles/tagged/'+getUrl;
    //console.log(createNewurl);
   window.location.replace(createNewurl);
      }, 100);
  });
  
  const url = window.location.href;
const lastPart = url.substring(url.lastIndexOf('/') + 1);
console.log(lastPart); // Output: "file.html"
  if(lastPart == 'articles'){
$( "<span class='breadcrumbs__current cstm_active_jtpl'></span>" ).insertAfter( "span.breadcrumbs__current" );
  }
  else{
$( "<span class='breadcrumbs__separator'> / </span> <span class='breadcrumbs__current cstm_active_jtpl'>"+lastPart+"</span>" ).insertAfter( "span.breadcrumbs__current" );
}
  // $('<div class="collapsibles-wrapper collapsibles-wrapper--border-bottom"></div>').insertBefore('.cbb-frequently-bought-container');
  $(window).on('scroll',function(event){
    var currentUrl = window.location.href;
    if(currentUrl.includes('#ruffruff')){
        var updatedUrl = currentUrl.split('#ruffruff')[0];
        window.history.replaceState({}, document.title, updatedUrl);
    }
  });

  var heights = $(".grid--uniform .grid__item .article__grid-meta .article__excerpt").map(function (){
    return $(this).height();
  }).get();

  maxHeight = Math.max.apply(null, heights);
  $(".grid--uniform .grid__item .article__grid-meta .article__excerpt").css('min-height', maxHeight);
  
  $(window).resize(()=>{
     var heights = $(".grid--uniform .grid__item .article__grid-meta .article__excerpt").map(function (){
        return $(this).height();
     }).get();
    
    maxHeight = Math.max.apply(null, heights);
    $(".grid--uniform .grid__item .article__grid-meta .article__excerpt").css('min-height', maxHeight);
  });

  $("#select-your-service-store-location").val('');
  $('#do-you-want-the-product-on-the-shipping-address-or-the-chosen-location').val('');
  
  var selctedAtt = $('select option:selected').attr('data-vartitle');
  var selctedVal = $('select option:selected').val();

   var searchParams = new URLSearchParams(window.location.search);
  if (searchParams.has('variant')) {
    var variantValue = searchParams.get('variant');
    if(variantValue == selctedVal){
      if ($('input[type="radio"][value="'+selctedAtt+'"]').length) {
        $('input[type="radio"][value="'+selctedAtt+'"]').prop('checked', true);
      }
    }
    
  }
  
  

  
  if(typeof $('.product-single__form .variant-wrapper .variant-input input').val() == 'undefined'){
    $(".shopify-payment-button").removeAttr("disabled","disabled");
  }
  else{
    //alert("variant");
  }
  if ($('.product-single__form .variant-wrapper .variant-input input').is(':checked')) {
  $(".shopify-payment-button").removeAttr("disabled","disabled");
  var get_exist = $(".product-single__variants option:selected").attr('data-exist-notify');
  var get_qty = $(".product-single__variants option:selected").attr('data-leftquantity');
    if (typeof get_exist  !== "undefined"){
  if(get_exist == 'true' && get_qty < 1 ){
  $(".product-single__form").addClass('unhide_bt');
  $(".product-single__form").removeClass('hide_btn');
  }else{
  $(".product-single__form").addClass('hide_btn');
  $(".product-single__form").removeClass('unhide_bt');
  }
  }else{
    $(".shopify-payment-button").attr("disabled","disabled");
    $(".product-single__form").addClass('hide_btn');
    $(".product-single__form").removeClass('unhide_bt');
  }

    }

  //************ payment button text change ************//
  setTimeout(function(){
   $("more-payment-options-link .shopify-payment-button__more-options").text("様々な決済方法が利用いただけます");
    $(".modal__inner more-payment-options-link .shopify-payment-button__more-options").text("様々な決済方法が利用いただけます");
  }, 50);
  $(".grid-product__content .quick-product__btn").click(function(){
    setTimeout(function(){
    $("more-payment-options-link .shopify-payment-button__more-options").text("様々な決済方法が利用いただけます");
      }, 1000);
  });
});

$(document).on("click",".custom-desktop-accordian .collapsible-trigger.collapsible-trigger-btn",function(e){
  var handle = $(this).attr("acc-handle").trim();
  var header_height = $("header.site-header").height();
  setTimeout(function(){
   if ($(".custom-desktop-accordian .collapsible-trigger[acc-handle='"+handle+"']").hasClass("is-open")) {
    $('html, body').animate({
      scrollTop: $(".custom-desktop-accordian .collapsible-trigger[acc-handle='"+handle+"']").offset().top - header_height

    }, 2000);
   }
  },500);
});
$(document).on("click",".user-guide-wrapp .main_buttons_wrapp .main_buttons a",function(e){
    e.preventDefault();
var handle = $(this).attr("data-handle").trim();
var header_height = $("header.site-header").height();
  var bar_height = $(".main_button_inner.is-sticky .main_buttons_wrapp").height();
  var bar_height_2 = $(".main_button_inner").height();
 if ($(".main_button_inner").hasClass("is-sticky")) {
  $('html, body').animate({
  scrollTop: $(".main_buttons_table_wrapp .table_heading-wrapp[data-handle='"+handle+"']").offset().top - header_height - bar_height - 50
}, 1200);
    }
   else{
     if ($(window).width() > 580) {
      $('html, body').animate({
     scrollTop: $(".main_buttons_table_wrapp .table_heading-wrapp[data-handle='"+handle+"']").offset().top - header_height - bar_height_2 - 100
        }, 1200);
     }
       else{
             $('html, body').animate({
     scrollTop: $(".main_buttons_table_wrapp .table_heading-wrapp[data-handle='"+handle+"']").offset().top - header_height - bar_height_2 - 160
        }, 1200);
       }
   }
});
$(document).on("click",".main_ducabike_page_wrapp .ducabike_sec a",function(e){
    e.preventDefault();
    var main_url =$(this).attr("href");
    var header_height =$(".site-header-sticky").height();
    $("html, body").animate({
        scrollTop:$("div"+main_url).offset().top- header_height
                          }, 2000);
});
$(document).on("click",".sc-project-ske-wrapp .main_buttons_wrapp .main_buttons a",function(e){
    e.preventDefault();
var handle = $(this).attr("data-handle").trim();
var header_height = $("header.site-header").height();
  var bar_height = $(".main_button_inner.is-sticky .main_buttons_wrapp").height();
  var bar_height_2 = $(".main_button_inner").height();
   if ($(".main_button_inner").hasClass("is-sticky")) {
  $('html, body').animate({
 scrollTop: $(".sc-project-ske-wrapp .custom_class_wrapp[data-handle='"+handle+"']").offset().top - header_height - bar_height - 70
}, 1200);
    }   else{
     if ($(window).width() > 580) {
      $('html, body').animate({
     scrollTop: $(".sc-project-ske-wrapp .custom_class_wrapp[data-handle='"+handle+"']").offset().top - header_height - bar_height_2 - 150
        }, 1200);
     }
       else{
             $('html, body').animate({
     scrollTop: $(".sc-project-ske-wrapp .custom_class_wrapp[data-handle='"+handle+"']").offset().top - header_height - bar_height_2 - 160
        }, 1200);
       }
   }
});
$(document).on("click",".back_to_top_wrapper",function(e){
console.log("test");

var body = $("html, body");
body.stop().animate({scrollTop:0}, 1000, 'swing', function() { 
});
});

function checkProductProperties(){
  var serviceLocation = $("#select-your-service-store-location").val();
  var storeLocation = $('#do-you-want-the-product-on-the-shipping-address-or-the-chosen-location').val();
  if(serviceLocation != '' && storeLocation != ''){
      var variant_length = $(".product-single__form .variant-wrapper .variant-input").length
      if(variant_length > 0){
        if ($('.product-single__form .variant-wrapper .variant-input input').is(':checked')) {
          $(".shopify-payment-button").removeAttr("disabled","disabled");
        }
      }
    else{
      $(".shopify-payment-button").removeAttr("disabled","disabled");
    }
    
  }
  else{
    $(".shopify-payment-button").attr("disabled","disabled");
     return false;
  }
}
  $(document).on('change','.upsell-checkbox', function(event){
        if($(this).is(':checked')){
            console.log("yes");
            $(".upshell_product").show();
            $(".upshell_main").hide();
           var serviceLocation = $("#select-your-service-store-location").val();
          //alert(serviceLocation);
          if(typeof serviceLocation != 'undefined'){
            checkProductProperties();
             $(document).on('change','#select-your-service-store-location', function(event){
               checkProductProperties();
             });
            $(document).on('change','#do-you-want-the-product-on-the-shipping-address-or-the-chosen-location', function(event){
               checkProductProperties();
             });
          }

            
        } else{
           
          $(".upshell_product").hide();
          $(".upshell_main").show();
          var variant_length = $(".product-single__form .variant-wrapper .variant-input").length
          if(variant_length > 0){
            if ($('.product-single__form .variant-wrapper .variant-input input').is(':checked')) {
              $(".shopify-payment-button").removeAttr("disabled","disabled");
            }
          } else{
            $(".shopify-payment-button").removeAttr("disabled","disabled");
          }
          
        }
      });
      $(document).on('change','.variant-input', function(event){
        if($(".upsell-checkbox").is(':checked')){
          $(".upshell_product").show();
          $(".upshell_main").hide();

          var serviceLocation = $("#select-your-service-store-location").val();
          //alert(serviceLocation);
          if(typeof serviceLocation != 'undefined'){
            checkProductProperties();
             $(document).on('change','#select-your-service-store-location', function(event){
               checkProductProperties();
             });
            $(document).on('change','#do-you-want-the-product-on-the-shipping-address-or-the-chosen-location', function(event){
               checkProductProperties();
             });
          }
          
        } else{
          $(".upshell_product").hide();
          $(".upshell_main").show();

          var variant_length = $(".product-single__form .variant-wrapper .variant-input").length
          if(variant_length > 0){
            if ($('.product-single__form .variant-wrapper .variant-input input').is(':checked')) {
              $(".shopify-payment-button").removeAttr("disabled","disabled");
            }
          } else{
            $(".shopify-payment-button").removeAttr("disabled","disabled");
          }
          
        }
      });

function cartChange2(total, ID, addOns, service){
  
  jQuery.ajax({  
    type: 'POST',
    url: '/cart/change.js',
    data:{
      id: ID,
      quantity: total
    },
    dataType: 'json',
    success: function(productid){
      jQuery.getJSON('/cart.js', function(cart) {
        jQuery.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function(cart){ 
                 
                $('.ajax_hit_here').html($(cart).find('.ajax_hit_here').html());
                $('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html($(cart).find('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html());
              
            }
        });
      }); 
    }
  }); 
}


function cartChange(event){



  var ID = event.attr('data-id');
  var total = parseInt(event.val());
  var addOns = event.attr('dataid');
  var service = event.attr('service-data');
  var removeProduct = event.attr('remove-product');
  var dataQuantity = event.attr('data-quantity');
  if(typeof dataQuantity != 'undefined' && dataQuantity == 'false'){
    var total = 0;
  }


// 👇 YAHAN LAGANA HAI
// Sirf main product delete hone par addon delete karo
if (total == 0 && addOns && service == 'true') {

    $('.cart__product-qty').each(function () {

        const id = $(this).attr('data-id');

        if (
            $(this).attr('dataid') == addOns &&
            $(this).attr('service-data') == 'false' &&
            id != ID
        ) {

            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                async: false,
                data: {
                    id: id,
                    quantity: 0
                },
                dataType: 'json'
            });

        }

    });

}
 
  jQuery.ajax({  
    type: 'POST',
    url: '/cart/change.js',
    async:false,
    data:{
      id: ID,
      quantity: total
    },
    dataType: 'json',
    complete: function(){
      if(addOns != '' && service == 'true'){
        $('.cart__row[bundle-id="'+addOns+'"]').find(".cart__product-qty").val(total);
        var ID2 = $('.cart__row[bundle-id="'+addOns+'"]').find(".cart__product-qty").attr('data-id');
        var addOns2 = $('.cart__row[bundle-id="'+addOns+'"]').find(".cart__product-qty").attr('dataid');
        var service2 = $('.cart__row[bundle-id="'+addOns+'"]').find(".cart__product-qty").attr('service-data');
        cartChange2(total, ID2, addOns2, service2);
      }
      if(addOns != '' && service == 'false' && total == 0){
        $('.cart__row[bundle-product="'+addOns+'"]').find(".cart__product-qty").val(total);
        var ID2 = $('.cart__row[bundle-product="'+addOns+'"]').find(".cart__product-qty").attr('data-id');
        var addOns2 = $('.cart__row[bundle-product="'+addOns+'"]').find(".cart__product-qty").attr('dataid');
        var service2 = $('.cart__row[bundle-product="'+addOns+'"]').find(".cart__product-qty").attr('service-data');
        var removeProduct2 = $('.cart__row[bundle-product="'+addOns+'"]').find(".cart__product-qty").attr('remove-product');
        if(removeProduct2 == 'true'){
          cartChange2(total, ID2, addOns2, service2);
        }
      }

    },
    success: function(productid){

      jQuery.getJSON('/cart.js', function(cartData) {
        cartData.items.forEach(item => {
          console.log(item);
        });

        let allItemsBackorder = true;
        let allItemsInStock = true;

        const stockArr = cartData.items.map(
          item => item.properties?.["在庫状況"] || ""
        );

        console.log(stockArr);

        // sab domestic stock wale
        const allInStock = stockArr.every(
          status => status === "国内在庫あり"
        );

        // sab backorder wale
        const allBackorder = stockArr.every(
          status => status === "お取り寄せ"
        );

        if (allInStock) {
          $(".all_instock").show();
          $(".all_backorder").hide();
          $(".all_mixed").hide();
          console.log('ALL INSTOCK');
        } else if (allBackorder) {
          $(".all_instock").hide();
          $(".all_backorder").show();
          $(".all_mixed").hide();
          console.log('ALL BACKORDER');
        } else {
          $(".all_instock").hide();
          $(".all_backorder").hide();
          $(".all_mixed").show();
          console.log('MIXED');
        }

        let interval;

        $(document).on('input', '#postal_code-input', function () {

          clearInterval(interval);

          interval = setInterval(() => {

            const spinner = document.querySelector('.loading-spinner');

            if (spinner && getComputedStyle(spinner).display !== 'none') {
              return;
            }

            setTimeout(() => {

              const text = document
                .querySelector('.estimated_delivery_time')
                ?.textContent
                ?.trim();

              if (text) {

                document.querySelectorAll('.estimated_delievery_date').forEach((el) => {
                  console.log("herer isgheugh")

                  const fonts = el.querySelectorAll('font');

                  if (fonts.length) {
                    fonts[fonts.length - 1].textContent = text;
                  } else {
                    el.textContent = text;
                  }

                });

                document.querySelectorAll('.delievery_text_invent_max').forEach((el) => {
                  el.style.display = 'inline';
                });

                $(".estimated_date_break").show();

              }

            }, 500);

            clearInterval(interval);

          }, 2000);

        });

        setTimeout(() => {

          function getSelectedValue(selector) {

            return $(selector).find('option:selected').val() || null;
            
          }

          function getTextareaValue(selector) {

            return $(selector).val() || null;

          }

          function getCheckedRadioValue(selector) {

            return $(selector + ':checked').val() || null;

          }

          function updateCartAttributes(attributes) {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { attributes },
              dataType: 'json',
              success: function (res) {
                console.log('Cart updated:', res.attributes);
              }
            });
          }

          // CHECK VISIBILITY
          function isAnyStockBlockVisible() {
            const backorder = document.querySelector('.all_backorder');
            const instock = document.querySelector('.all_instock');

            const backorderVisible = !!(
              backorder &&
              (
                window.getComputedStyle(backorder).display !== 'none' &&
                window.getComputedStyle(backorder).visibility !== 'hidden' &&
                backorder.offsetParent !== null
              )
            );

            const instockVisible = !!(
              instock &&
              (
                window.getComputedStyle(instock).display !== 'none' &&
                window.getComputedStyle(instock).visibility !== 'hidden' &&
                instock.offsetParent !== null
              )
            );

            return backorderVisible || instockVisible;
          }

          // 1️⃣ CLEAR ALL ATTRIBUTES FIRST
          function clearCartAttributes(callback) {
            const emptyAttributes = {
              '配送時間指定': '',
              '配送に関する指示': '',
              '注文メモ': '',
              '配送に関するガイドライン': ''
            };

            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: { attributes: emptyAttributes },
              dataType: 'json',
              success: function () {
                console.log('Cart attributes cleared');
                if (callback) callback();
              }
            });
          }

          // 2️⃣ SYNC FROM DOM
          function syncDOMToCart() {

            const skipGuideline = isAnyStockBlockVisible();
            const attributes = {
              '配送時間指定': getSelectedValue('select[name="attributes[配送時間指定]"]'),
              '配送に関する指示': getSelectedValue('select[name="attributes[配送に関する指示]"]'),
              // '注文メモ': getTextareaValue('textarea[name="note"]')
            };

            // 👉 ONLY ADD THIS IF CONDITION IS FALSE
            if (!skipGuideline) {
              console.log("not skipped its added");
              attributes['配送に関するガイドライン'] = getCheckedRadioValue(
                'input[name="attributes[配送に関するガイドライン]"]'
              );
            }
            else{

              console.log("skipped not added");
            }

            Object.keys(attributes).forEach(key => {
              if (!attributes[key]) delete attributes[key];
            });

            updateCartAttributes(attributes);
          }

          // 3️⃣ FLOW: CLEAR → SYNC
          clearCartAttributes(function () {
            syncDOMToCart();
          });

        }, 1500);

        $(document).on('click', 'input[name="attributes[配送に関するガイドライン]"]', function () {

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              attributes: {
                '配送に関するガイドライン': this.value
              }
            },
            dataType: 'json',
            success: function(res) {
              console.log(res.attributes);
            }
          });

        });

        $(document).on('change', 'select[name="attributes[配送時間指定]"]', function () {

          const value = this.value;
          const $select = $(this);

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              attributes: {
                '配送時間指定': value
              }
            },
            dataType: 'json',
            success: function(res) {
              console.log(res.attributes);

              $select.find('option').removeAttr('selected');

              $select.find('option').each(function() {
                if ($(this).val() === value) {
                  $(this).attr('selected', '');
                }
              });
            }
          });

        });

        $(document).on('change', 'select[name="attributes[配送に関する指示]"]', function () {

          const value = this.value;
          const $select = $(this);

          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {
              attributes: {
                '配送に関する指示': value
              }
            },
            dataType: 'json',
            success: function(res) {
              console.log(res.attributes);

              $select.find('option').removeAttr('selected');

              $select.find('option').each(function() {
                if ($(this).val() === value) {
                  $(this).attr('selected', '');
                }
              });
            }
          });

        });

        let timer1;

        // $(document).on('input', 'textarea[name="note"]', function () {

        //   const value = this.value;

        //   clearTimeout(timer1);

        //   timer1 = setTimeout(() => {

        //     $.ajax({
        //       type: 'POST',
        //       url: '/cart/update.js',
        //       data: {
        //         attributes: {
        //           '注文メモ': value
        //         }
        //       },
        //       dataType: 'json',
        //       success: function(res) {
        //         console.log(res.attributes);
        //       }
        //     });

        //   }, 600);

        // });

          jQuery.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            success: function (cartHtml) {

              // Current values
              const estimatedDate = $('.estimated_delievery_date').first().text().trim();
              const postalCode = $('#postal_code-input').val().trim();

              // Old localStorage data
              const oldData = JSON.parse(localStorage.getItem('deliveryData')) || {};

              // Sirf jab dono values blank na ho tabhi localStorage update karo
              if (postalCode !== '' && estimatedDate !== '') {
                localStorage.setItem(
                  'deliveryData',
                  JSON.stringify({
                    postalCode: postalCode,
                    estimatedDate: estimatedDate
                  })
                );
              }

              // Replace cart HTML
              $('.ajax_hit_here').html(
                $(cartHtml).find('.ajax_hit_here').html()
              );

              // Update cart icon
              $('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart')
                .html(
                  $(cartHtml)
                    .find('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart')
                    .html()
                );

                cartUpdating = false;

                setTimeout(function () {

                      // Restore values from localStorage
                      const storedData = JSON.parse(localStorage.getItem('deliveryData')) || {};

                      if (storedData.postalCode) {
                        $('#postal_code-input').val(storedData.postalCode);
                        $('#postal_code-input_str').val(storedData.postalCode);
                      }

                      if (storedData.estimatedDate) {

                        $(".delievery_text_invent_max").show();
                        $(".estimated_date_break").show();

                        document.querySelectorAll('.estimated_delievery_date').forEach(function (el) {

                          const fonts = el.querySelectorAll('font');

                          if (fonts.length) {
                            fonts[fonts.length - 1].textContent = storedData.estimatedDate;
                          } else {
                            el.textContent = storedData.estimatedDate;
                          }

                        });

                      }


            },500);

              jQuery.getJSON('/cart.js', function (cartData) {
                console.log('Cart attributes:', cartData.attributes);
              });

            },
            error: function (xhr) {
              console.error(xhr);
            }
          }); 



      }); 
    } 
  }); 
} 
$(document).on('change','.cart__product-qty ',function(evt){
  var event= $(this);
  var getCart = cartChange(event);
});
$(document).on('keyup','.cart__product-qty ',function(evt){
  var event= $(this);
  var getCart = cartChange(event);
});
$(document).on("click",".cart_data_remove",function(event){
  var event= $(this);
  var getCart = cartChange(event);
  var addOns = event.attr('dataid');
  $('.cart__row[bundle-product="'+addOns+'"]').find(".cart__product-qty").val(0);
});
  $(document).ready(function(){
        $(".product_checkbox_button .container_aa .upsell-checkbox").prop('checked', false); 
          $(".cstm_topbtn").on('click',function() {
            $('html,body').animate({
                scrollTop: $("#shopify-section-new-landing-banner-section").offset().top-100},
                'slow');
        });
         
     
    // $(".product-single__description ul li span").click(function(){
    //     $(".overlay_main-pro").show();
    // });


        $(".product-single__description table a ").click(function(e){
    var main_url = $(this).attr("href");
    if(main_url == '#custom_popup'){
        e.preventDefault();
        $(".overlay_main-pro").show();
    }
});
$(".popup_cross_icon").click(function(e){
        $(".overlay_main-pro").hide();
   $("body").removeClass("is-open-popup-body");
});


$(window).on('load resize scroll mousemove', function(){
    if ($(window).width() >= 1201) {
      // BLue bag js right side length
      var wdthBluBag = $('.in_stock_custom_japan').width();
      $('span.custom_road_roacker_tag.with_instock_tag').css('right', wdthBluBag + 20);
      // Yellow bag js right side length
      var wdthYloBag = $('.custom-label').width();
      $('.jtpl-new-product span.custom_road_roacker_tag').css('right', wdthYloBag + 20);
      $('span.custom_road_roacker_tag').css('right', wdthYloBag + 20);
      // Without Color Bag visible
      var wdthNtoRdBag = $('.custom-label').width();
      $('.jtpl-product span.custom_road_roacker_tag').css('right', wdthNtoRdBag + 20);
      $('span.custom_road_roacker_tag').css('right', wdthNtoRdBag + 20);
    }else{
       $('span.custom_road_roacker_tag').css('right', 0);
    }
});

    
      });

function addcart2(item) {
 
  var storeLocation = $('#do-you-want-the-product-on-the-shipping-address-or-the-chosen-location').val();
  var serviceLocation = $("#select-your-service-store-location").val();
  var serviceLocationTitle = $('#select-your-service-store-location').attr('data-title');
  // var variant_length = $(".product-single__form .variant-wrapper .variant-input").length;
  var variant_length = $(".product-single__form .variant-wrapper").length;
  
  if($('.upsell-checkbox').is(':checked')){
      if(serviceLocation == ''){
        $(".service-store-location-error").show();
        return;
      }
      else{
        $(".service-store-location-error").hide();
      }
      if(storeLocation == ''){
        $(".shiping_storelocator-error").show();
        return;
      }
      else{
         $(".shiping_storelocator-error").hide();
      }
      var get_iddd = $("select.product-single__variants").val();
      if(typeof serviceLocation !== 'undefined' && serviceLocation !== 'undefined'){
        
        var productPropertiesData = serviceLocation + '_' + storeLocation + '_' + get_iddd;
        var productProperties = productPropertiesData.replace(/\s/g, '_');
      }
      else{
        var productProperties = get_iddd;
      }
  }
  if(variant_length > 0){
    // alert("here");
    // var allVariantsSelected = true;
    // $('.product-single__form .variant-wrapper').each(function () {
    //   if (!$(this).find('.variant-input input:checked').length) {
    //     allVariantsSelected = false;
    //   }
    // });
    var allVariantsSelected = true;
    var missingVariants = [];

    $('.product-single__form .variant-wrapper').each(function () {
      var $wrapper = $(this);

      if (!$wrapper.find('.variant-input input:checked').length) {
        allVariantsSelected = false;

        // jo variant select nahi hua uska label lo
        var labelText = $wrapper.find('.variant__label').first().text().replace(':', '').trim();

        if (labelText) {
          missingVariants.push(labelText.toLowerCase());
        }
      }
    });

    if (allVariantsSelected) {
      $(".Dummy-error-message").addClass("remove-error-message");
      var productid = $(item).attr('data-id');
      var quantity = $(".product__quantity.product__quantity--button .js-qty__num").val();

  var final_val = $('.product-single__variants').find(":selected").attr("data-stockval");
  var data_vendor = $('.product-single__variants').find(":selected").attr("data-vendor");
 if ($('.estimated_delivery_time').is(':visible')) {
     const interval = setInterval(() => {

            const delieveryTime = $('.estimated_delivery_time').text().trim();

              if (delieveryTime !== "") {
                   clearInterval(interval);

                    const deliveryText = "最短お届け予定日:"

                      if (typeof(data_vendor) != "undefined")
  {
    
    var data = {
        id: productid,
        properties: { 
        在庫状況 : final_val, 
        納期 :data_vendor, 
        '商品のお届け先':storeLocation,
        'ご選択頂いたショップ':serviceLocation,
        '_bundle_product_':productProperties,
         お届け予定日時:delieveryTime,
      },
          quantity: quantity
        }; 

       console.log(data);
  }
      else{
        
      var data = {
          id: productid,
          properties: { 
            在庫状況 : final_val,
            '商品のお届け先':storeLocation,
            'ご選択頂いたショップ':serviceLocation,
            '_bundle_product_':productProperties,
            お届け予定日時:delieveryTime,
          },
          quantity: quantity
        }; 
      }
     
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:data,
        dataType: 'json',
        beforeSend: function(){
          $("span.adding_to_cart_text").show();
          $("span.add_to_cart_text").hide();
        },
        success: function(productid){
          jQuery.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            success: function(cart){
              $("span.adding_to_cart_text").hide();
              $("span.add_to_cart_text").hide();
              $("span.added_to_cart_text").show();
              $("p.ajaxified-cart-feedback.success").show();
              setTimeout(function(){
                $("span.adding_to_cart_text").hide();
                $("span.add_to_cart_text").show();
                $("span.added_to_cart_text").hide();
              },1200);

              $('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html($(cart).find('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html());
            },
          });
        },
      });





              }

      },200);
 }
  else{

          if (typeof(data_vendor) != "undefined")
  {
    
    var data = {
        id: productid,
        properties: { 
        在庫状況 : final_val, 
        納期 :data_vendor, 
        '商品のお届け先':storeLocation,
        'ご選択頂いたショップ':serviceLocation,
        '_bundle_product_':productProperties,
      },
          quantity: quantity
        }; 

       console.log(data);
  }
      else{
        
      var data = {
          id: productid,
          properties: { 
            在庫状況 : final_val,
            '商品のお届け先':storeLocation,
            'ご選択頂いたショップ':serviceLocation,
            '_bundle_product_':productProperties,
          },
          quantity: quantity
        }; 
      }
     
      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data:data,
        dataType: 'json',
        beforeSend: function(){
          $("span.adding_to_cart_text").show();
          $("span.add_to_cart_text").hide();
        },
        success: function(productid){
          jQuery.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            success: function(cart){
              $("span.adding_to_cart_text").hide();
              $("span.add_to_cart_text").hide();
              $("span.added_to_cart_text").show();
              $("p.ajaxified-cart-feedback.success").show();
              setTimeout(function(){
                $("span.adding_to_cart_text").hide();
                $("span.add_to_cart_text").show();
                $("span.added_to_cart_text").hide();
              },1200);

              $('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html($(cart).find('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html());
            },
          });
        },
      });
  }

    }else{
      // $(".Dummy-error-message").removeClass("remove-error-message");
  //     var errorText = '選択してください';

  // if (missingVariants.length === 1) {
  //   errorText += missingVariants[0];
  // } else if (missingVariants.length === 2) {
  //   errorText += missingVariants[0] + 'そして' + missingVariants[1];
  // } else if (missingVariants.length > 2) {
  //   errorText += missingVariants.slice(0, -1).join(', ') +
  //     'そして' + missingVariants[missingVariants.length - 1];
  // }
  var errorText = '';

if (missingVariants.length === 1) {
  errorText = missingVariants[0];
} else if (missingVariants.length === 2) {
  errorText = missingVariants[0] + 'と' + missingVariants[1];
} else if (missingVariants.length > 2) {
  errorText =
    missingVariants.slice(0, -1).join(', ') +
    'と' +
    missingVariants[missingVariants.length - 1];
}

// last me add hoga
errorText += 'を選択してください';


  $(".Dummy-error-message")
    .text(errorText)
    .removeClass("remove-error-message");
console.log("remove-error-message custom js");
  return;
    }
  }
  else{
     
        var productid = $(item).data('id');
        var quantity = $(".product__quantity.product__quantity--button .js-qty__num").val();
        var final_val = $('.product-single__variants').find(":selected").attr("data-stockval");
        var data_vendor = $('.product-single__variants').find(":selected").attr("data-vendor");



if ($('.estimated_delivery_time').is(':visible')) {
const interval = setInterval(() => {

    const delieveryTime = $('.estimated_delivery_time').text().trim();

    if (delieveryTime !== "") {
              clearInterval(interval);

              const deliveryText = "最短お届け予定日:"

              console.log(delieveryTime);
              console.log(deliveryText);

              // Yahan apna baaki code likho
          
          
              if (typeof(data_vendor) != "undefined")
              {
                // alert("1");

                var data = {
                      id: productid,
                  properties: { 在庫状況 : final_val, 納期 :data_vendor, 商品のお届け先:storeLocation,
                  ご選択頂いたショップ:serviceLocation, _bundle_product_:productProperties,お届け予定日時:delieveryTime},
                      quantity: quantity
                      
                    }; 
                    console.log("its line items=>>>>>>>>>>>>>>>>>>");
              }
                  else{
                    // alert("2");
                  var data = {
                      id: productid,
                      properties: { 在庫状況 : final_val,商品のお届け先:storeLocation,
                  ご選択頂いたショップ:serviceLocation, _bundle_product_:productProperties,お届け予定日時:delieveryTime},
                      quantity: quantity
                    }; 
                  }
            
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data:data,
            dataType: 'json',
            beforeSend: function(){
              $("span.adding_to_cart_text").show();
              $("span.add_to_cart_text").hide();
            },
            success: function(productid){
              jQuery.ajax({
                type: 'GET',
                url: '/cart',
                dataType: 'html',
                success: function(cart){
                  $("span.adding_to_cart_text").hide();
                  $("span.add_to_cart_text").hide();
                  $("span.added_to_cart_text").show();
                  $("p.ajaxified-cart-feedback.success").show();
                  setTimeout(function(){
                    $("span.adding_to_cart_text").hide();
                    $("span.add_to_cart_text").show();
                    $("span.added_to_cart_text").hide();
                  },1200);

                  $('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html($(cart).find('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html());
                },
              });
            },
          });
    }
  },200)
}
else{
      if (typeof(data_vendor) != "undefined")
              {
                // alert("1");

                var data = {
                      id: productid,
                  properties: { 在庫状況 : final_val, 納期 :data_vendor, 商品のお届け先:storeLocation,
                  ご選択頂いたショップ:serviceLocation, _bundle_product_:productProperties,},
                      quantity: quantity
                      
                    }; 
                    console.log("its line items=>>>>>>>>>>>>>>>>>>");
              }
                  else{
                    // alert("2");
                  var data = {
                      id: productid,
                      properties: { 在庫状況 : final_val,商品のお届け先:storeLocation,
                  ご選択頂いたショップ:serviceLocation, _bundle_product_:productProperties,},
                      quantity: quantity
                    }; 
                  }
            
          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data:data,
            dataType: 'json',
            beforeSend: function(){
              $("span.adding_to_cart_text").show();
              $("span.add_to_cart_text").hide();
            },
            success: function(productid){
              jQuery.ajax({
                type: 'GET',
                url: '/cart',
                dataType: 'html',
                success: function(cart){
                  $("span.adding_to_cart_text").hide();
                  $("span.add_to_cart_text").hide();
                  $("span.added_to_cart_text").show();
                  $("p.ajaxified-cart-feedback.success").show();
                  setTimeout(function(){
                    $("span.adding_to_cart_text").hide();
                    $("span.add_to_cart_text").show();
                    $("span.added_to_cart_text").hide();
                  },1200);

                  $('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html($(cart).find('a.site-nav__link.site-nav__link--icon.js-drawer-open-cart').html());
                },
              });
            },
          });
}





  }
}
if($('.main_button_inner').length > 0){
var distance = $('.main_button_inner').offset().top - 50,
     distance2 = $('.main_button_inner').offset().top - 100,
    $window = $(window);
$window.scroll(function() {
    if ( $window.scrollTop() >= distance ) {
       $('.main_button_inner').addClass('is-sticky');
    } else if ( $window.scrollTop() < distance2 ) {
       $('.main_button_inner').removeClass('is-sticky');
    }
});

}
  




